import "./ScoreCard.css";
import ScoreCardRow from "./ScoreCardRow";
import PenaltyRow from "./PenaltyRow";
import { ScoreCardInfo } from "./common/Info";
import { useAppSelector } from "./store";

type ScoreCardProps = {
  playerName: string;
  scoreCard: ScoreCardInfo;
  size: string;
  playable: boolean;
};

function ScoreCard({ scoreCard, size, playable, playerName }: ScoreCardProps) {
  const game = useAppSelector((state) => {
    return state.game;
  });

  function isLocked(color: string): boolean {
    switch (color) {
      case "red":
        return game.redLocked;
      case "yellow":
        return game.yellowLocked;
      case "blue":
        return game.blueLocked;
      case "green":
        return game.greenLocked;
      default:
        return false;
    }
  }

  return (
    <div className="scoreCard centerContainer">
      <div className="otherScoreCardHeader">
        <h3>{playerName}</h3>
      </div>
      <ScoreCardRow
        color="red"
        data={scoreCard.red}
        isLocked={isLocked("red")}
        size={size}
        playable={playable}
      />
      <ScoreCardRow
        color="yellow"
        data={scoreCard.yellow}
        isLocked={isLocked("yellow")}
        size={size}
        playable={playable}
      />
      <ScoreCardRow
        color="green"
        data={scoreCard.green}
        isLocked={isLocked("green")}
        size={size}
        playable={playable}
      />
      <ScoreCardRow
        color="blue"
        data={scoreCard.blue}
        isLocked={isLocked("blue")}
        size={size}
        playable={playable}
      />
      <PenaltyRow count={scoreCard.penalties} size={size} playable={playable} />
    </div>
  );
}

export default ScoreCard;
